<script>

import bnvform from '@/vue-model-mirror/bnvform';
import { formpage } from '@/vue-model-mirror';

const schemas = require('@/schemaconfig');

export default {
    name: 'extraction-form',
    extends: formpage,
    components: {
        bnvform,
    },
    executed() { console.log( this.executed ); },
    watch: {
        executed( newval, oldval ) {
            if ( newval === true && oldval === false ) {
                this.upload_file();
            }
        },
        uploaded( newval, oldval ) {
            if ( newval === true && oldval === false ) {
                console.log('processo terminato');
                this.uploading = false;
                this.$router.push( '/item/qrcode/' + this.$store.state.item.obj.id );
            }
        },
    },
    computed: {
        executed() { return this.$store.state.item.created; },
        uploaded() { return this.$store.state.item.uploaded; },
        user_id() {
            return JSON.parse( localStorage.getItem('user') ).id;
        },
        company_id() {
            return JSON.parse( localStorage.getItem('user') ).company.id;
        },
        is_edit() {
            return ( this.record && this.record[ this.pk ? this.pk : 'id' ] ) ? true : false;
        },
    },
    methods: {
        upload_file() {
            this.uploading = true;
            this.$store.dispatch('item/upload_file', this.data.file );
        },
        operation_success: function( data ) {
            if ( data.hasOwnProperty('file') === false ) {
                console.log( this.$refs['bnvform'] );
                this.$refs['bnvform'].operation_success( data );
                return;
            }
            this.data = data;
            // test 
            data.created_by = this.user_id;
            data.company_id = this.company_id;
            // /test
            this.$store.dispatch('item/create', { payload: data, include: false });
//          var file_number = data.file.length;
//          if ( file_number > 0 ) {
//              var title = 'Coda di upload';
//              var body = `${ file_number } file aggiunti`;
//              this.make_toast( title.toUpperCase(), body );
//              this.$store.dispatch('extraction/upload_queue');
//              this.$refs.bnvform.reset_form();
//          }
        },
        make_toast(title, body) {
            this.$bvToast.toast( body, {
                title         : title,
                autoHideDelay : 2500,
                appendToast   : true,
            });
        },
    },
    data () {
        return {
            data: null,
            uploading : false,
        }
    },
};

</script>

<template>

    <div>
        <h3 style="text-align: center; padding-bottom: 14px;">{{ is_edit ? 'MODIFICA' : 'NUOVO' }} DOCUMENTO</h3>
        <bnvform
            v-if       = "started === true && uploading === false"
            ref        = "bnvform"
            :name      = "schema_name"
            :schema    = "schema"
            :options   = "options"
            :record    = "record"
            :inline    = "inline"
            :submit    = "false"

            :key       = "form_reload"
            @reset     = "reset_form"
            @submitted = "operation_success"
        ></bnvform>
        <div class="text-center" v-if="uploading" style="margin-top: 40px">
            <div class="spinner-grow text-dark" role="status" style="width: 6rem; height: 6rem;">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="text-center">upload in corso...</p>
        </div>
    </div>

</template>


